<script setup lang="ts">
const telestrationStore = useTelestrationStore();
</script>

<template>
  <div class="relative z-0">
    <TShapesToolbar v-show="telestrationStore.telestrationMode === TelestrationMode.EDIT" />
    <TStage />
    <TShapesTransformer />
  </div>
</template>
